import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let token = null;
try { token = localStorage.getItem("dz_token"); } catch (e) {}
if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export function setToken(t) {
  token = t;
  try {
    if (t) localStorage.setItem("dz_token", t);
    else localStorage.removeItem("dz_token");
  } catch (e) {}
  if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  else delete api.defaults.headers.common["Authorization"];
}

export function getToken() { return token; }

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function trackEvent(event, meta = {}) {
  try {
    api.post("/events", { event, meta, page: window.location.pathname });
    if (window.gtag) window.gtag("event", event, meta);
    if (window.dataLayer) window.dataLayer.push({ event, ...meta });
  } catch (e) {}
}

export default api;
